<template>
  <div>
    <v-card outlined class="rounded-card">
      <v-subheader class="grey lighten-2">
        <px-aprovacao-solicitacao-item-header :aprovacao="aprovacao"/>
      </v-subheader>
      <div>
        <px-aprovacao-solicitacao-item-content :aprovacao="aprovacao"/>
      </div>
    </v-card>
  </div>
</template>

<script>
import AprovacaoSolicitacaoItemContent
  from '@/modules/aprovacao-solicitacao/AprovacaoSolicitacaoItemContent.vue';
import AprovacaoSolicitacaoItemHeader
  from '@/modules/aprovacao-solicitacao/AprovacaoSolicitacaoItemHeader.vue';

export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
  components: {
    pxAprovacaoSolicitacaoItemContent: AprovacaoSolicitacaoItemContent,
    pxAprovacaoSolicitacaoItemHeader: AprovacaoSolicitacaoItemHeader,
  },
};
</script>
